import React, { useState, useRef } from 'react';
import LoadingBar from 'app/components/common/LoadingBar';
import useIsMounted from 'app/hook/common/useIsMounted';

export const PendingContext = React.createContext();

const PendingContextProvider = ({ children = null }) => {
	const [pending, setPending] = useState(false);
	const pendingRef = useRef(false);
	const isMounted = useIsMounted();
	const executeWithPending = (fnc) => {
		const returnFunction = async () => {
			if (pendingRef.current) return console.log('pending...');
			try {
				pendingRef.current = true;
				setPending(true);
				const returnValue = await fnc();
				return returnValue;
			} catch (error) {
				throw error;
			} finally {
				if (isMounted()) {
					setPending(false);
				}
				pendingRef.current = false;
			}
		};

		return returnFunction;
	};

	return (
		<PendingContext.Provider value={{ executeWithPending }}>
			{children}
			{pending && <LoadingBar />}
		</PendingContext.Provider>
	);
};

export default PendingContextProvider;
